import React, { useState } from "react";
import Layout from "../../../component/Layout";
import TestHeader from "../Test/TestHeader";
import greenClock from "../../../images/greenClock.svg";
import { Link } from "react-router-dom";
const Train = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleAccordion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return (
    <Layout>
      <div className="relative h-full testbg pb-5 overflow-y-auto">
        <TestHeader />
        <div className="w-full max-w-2xl mx-auto py-[15px]">
          {weeks.map((week, index) => (
            <div key={index} className={`${openIndex === index && "!border-0 bg-[#242424]"} py-[15px]  px-5 border-b border-white/20 last:border-b last:border-white/20 first:border-b first:border-white/20 last:pb-[15px]`}>
              {/* Accordion button */}
              <button
                className="w-full flex justify-between items-center gap-5 text-white text-base font-normal"
                onClick={() => toggleAccordion(index)}
              >
                <p>{week.week}</p>
                <span
                  className={`transform transition-transform ${
                    openIndex === index ? "rotate-180" : ""
                  }`}
                >
                  <ArrowD />
                </span>
              </button>
              {/* Inner items */}
              {openIndex === index && (
                <div className="p-[0px_0px_0px_15px]">
                  {week.days.map((day, i) => (
                    <div
                      key={i}
                      className="p-[15px_0px] flex justify-between items-center border-b border-white/20 last:border-b-0 last:!pb-0"
                    >
                      <Link to="/trainstep2"
                        className={`text-white text-base font-normal ${
                          day.hasClock
                            ? "underline underline-offset-4 decoration-[#F0C231]"
                            : ""
                        }`}
                      >
                        {day.name}
                      </Link>
                      {day.hasClock && (
                        <img
                          src={greenClock}
                          alt="green"
                          className="object-contain"
                        />
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>

      </div>
    </Layout>
  );
};

export default Train;

const ArrowL = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
    >
      <path
        d="M7 13L1 7L7 1"
        stroke="#FFFEFF"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const ArrowD = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="8"
    viewBox="0 0 14 8"
    fill="none"
  >
    <path
      d="M13 1L7 7L1 1"
      stroke="white"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

const weeks = [
  {
    week: "Week 1",
    days: [
      { name: "Monday", hasClock: true },
      { name: "Tuesday", hasClock: false },
    ],
  },
  {
    week: "Week 2",
    days: [
      { name: "Monday", hasClock: true },
      { name: "Tuesday", hasClock: false },
    ],
  },
  {
    week: "Week 3",
    days: [
      { name: "Monday", hasClock: true },
      { name: "Tuesday", hasClock: false },
    ],
  },
  {
    week: "Week 4",
    days: [
      { name: "Monday", hasClock: true },
      { name: "Tuesday", hasClock: false },
    ],
  },
  {
    week: "Week 5",
    days: [
      { name: "Monday", hasClock: true },
      { name: "Tuesday", hasClock: false },
    ],
  },
  {
    week: "Week 6",
    days: [
      { name: "Monday", hasClock: true },
      { name: "Tuesday", hasClock: false },
    ],
  },
];
